<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-boxes" texto-titulo="Actualizar stock"></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <form @submit.prevent="guardarArticulo()">
          <div class="row">
            <FloatLabel label="Código" clase="offset-md-2 col-md-4 col-12">
              <input
                v-model="articulo.codigo"
                id="codigo"
                inputmode="numeric"
                placeholder="Código"
                type="text"
                class="form-control"
              />
            </FloatLabel>
            <div class="col-md-2 col-12">
              <button type="button" @click="buscarArticulo" class="btn btn-info btn-block">Buscar</button>
            </div>
            <div class="col-md-2 col-12">
              <button type="button" @click="modalArticulo= true" class="btn btn-info btn-block">Buscar por nombre</button>
            </div>
            <h4 class="w-100 text-center">{{articulo.descripcion}}</h4>
            <FloatLabel label="Stock actual" clase="offset-md-3 col-md-6 col-12">
              <input
                v-model="articulo.stock"
                id="stock"
                placeholder="0.00"
                readonly
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.articulo.stock.required || !$v.articulo.stock.decimal)) ? 'is-invalid' : ''"
              />
            </FloatLabel>
            <FloatLabel label="Stock entrante:" clase="offset-md-3  col-md-6 col-12">
              <input
                v-model="stock_entrante"
                id="stock_entrante"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.stock_entrante.required || !$v.stock_entrante.decimal)) ? 'is-invalid' : ''"
              />
            </FloatLabel>
            <FloatLabel label="Stock actualizado:" clase="offset-md-3  col-md-6 col-12">
              <input
                v-model="stock_actualizado"
                id="stock_actualizado"
                placeholder="0.00"
                readonly
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.stock_actualizado.required || !$v.stock_actualizado.decimal)) ? 'is-invalid' : ''"
              />
            </FloatLabel>
          </div>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
      <ModalSelectArticulo ref="selectArticulo"
        v-if="modalArticulo"
        @selectArticulo="onSelectArticulo"
        @cerrarModalArticulo="modalArticulo = false"
      ></ModalSelectArticulo>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import ModalSelectArticulo from "@/components/views/articulos/ModalSelectArticulo";
import BlockUI from "@/components/loaders/BlockUI";
import { required, decimal } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Articulo from "@/models/articulo";
export default {
  name: "ActualizarStock",
  components: {
    TituloComponent,
    ModalSelectArticulo,
    FloatLabel,
    BlockUI,
  },
  data() {
    return {
      articulo: new Articulo(
        null,
        null,
        "",
        null,
        null,
        null,
        null,
        null,
        null,
        5
      ),
      stock_actualizado: 0,
      stock_entrante: 0,
      loading: false,
      enviado: false,
      modalArticulo: false,
    };
  },
  validations: {
    articulo: {
      stock: { required, decimal },
    },
    stock_entrante: { required, decimal },
    stock_actualizado: { required, decimal },
  },
  watch: {
    stock_entrante: function () {
      this.calcularNuevoStock();
    },
  },
  mounted() {},
  methods: {
    guardarArticulo() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      this.articulo.stock = this.stock_actualizado;
      axios
        .put("/articulos/" + this.articulo.id, this.articulo)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.articulo.descripcion} se guardó con éxito.`,
            });

            this.articulo = new Articulo(
              null,
              null,
              "",
              null,
              null,
              0,
              null,
              null,
              null,
              5
            );
            this.stock_actualizado = 0;
            this.stock_entrante = 0;
            this.enviado = false;
            document.getElementById('codigo').focus();
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
    buscarArticulo() {
      if (isNaN(this.articulo.codigo)) {
        Swal.fire({
          icon: "error",
          title: "Oopss..",
          text: `Debe ingresar el código.`,
        });
        return false;
      }
      this.loading = true;
      axios
        .get("articulos/por-codigo/" + this.articulo.codigo)
        .then((res) => {
          if (res.data.success) {
            this.articulo = res.data.articulo;
            this.calcularNuevoStock();
            document.getElementById("stock_entrante").focus();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oopss..",
              text: `No se ha encontrado el artículo.`,
            });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha encontrado el artículo.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSelectArticulo(articulo) {
      this.articulo = articulo;
      this.calcularNuevoStock();
      this.modalArticulo= false;
    },
    calcularNuevoStock() {
      if (isNaN(parseFloat(this.stock_entrante))) {
        this.stock_actualizado = parseFloat(this.articulo.stock) + 0;
      }else{
          this.stock_actualizado =
            parseFloat(this.articulo.stock) + parseFloat(this.stock_entrante);
      }
    },
  },
};
</script>
